export default __webpack_public_path__ + "static/media/alertDotIcon.985e5406.svg";